module.exports = __webpack_public_path__ + "assets/img/avatar-1.bf37e594.jpg";